import React from 'react'
import { RiExternalLinkLine } from 'react-icons/ri'

type ExternalLinkProps = {
  children?: React.ReactNode
} & React.AnchorHTMLAttributes<HTMLAnchorElement>

const ExternalLink = ({ children, ...rest }: ExternalLinkProps) => {
  return (
    <a {...rest} className="font-medium text-fl-ocean underline inline-flex flex-row gap-[0.2em] items-center mr-[0.2em]">
      {children}
      <RiExternalLinkLine size="0.8em" className="mr-0!" />
    </a>
  )
}

export default ExternalLink